import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";
import './HasWorkExperienceQuestionView.scss'

export const HasWorkExperienceQuestionView = (props) => {
    const dispatch = useDispatch();
    
    const handleNext = hasWorkExperience => () => {

        const nextPath = hasWorkExperience ? ROUTE_PATH.MRA_IS_CANADA_RESIDENT : ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE_NO
        dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`))
    }

    return (
        <div className="container" >
            {/* Title */}
            <div className="row" >
                <div className="col-xs-12 col-lg-8">
                    <h1>Work experience requirement</h1>
                </div>
            </div>

            {/* Information Paragraphs */}
            <div className="row">
                <div className="col-lg-8">
                    <p>
                        You must meet at least 1 of the following criteria to become a principal broker for your brokerage:
                    </p>
                    <ul className="dashed spaced">
                        <li>You have a current Mortgage Broker licence or equivalent in one of the following provinces:
                            <ul className="dashed indented">
                                <li>Alberta</li>
                                <li>British Columbia</li>
                                <li>Manitoba</li>
                                <li>New Brunswick</li>
                                <li>Ontario</li>
                                <li>Quebec</li>
                                <li>Saskatchewan</li>
                                <li>Nova Scotia</li>
                            </ul>
                        </li>
                        <li>You brokered mortgages for a federally regulated financial institution for at least 24 of the 36 months immediately before the date of your application.</li>
                    </ul>

                    <p>Do you meet this criteria?</p>
                </div>
            </div>
            {/* Yes/No Answer */}
            <div className="row">
                <div className="col-lg-2 ">
                    <Button
                        className={"ns-btn-yes-no btn-default"}
                        buttonType="primary_regular"
                        onClick={handleNext(true)}
                        text={"Yes"}
                    />
                </div>

                <div className="col-lg-3">
                    <Button
                            className={"ns-btn-yes-no btn-default"}
                            buttonType="primary_regular"                           
                        onClick={handleNext(false)}
                        value={false}
                        text={"No"}
                    />
                </div>
            </div>
        </div>
    )
}